import React from 'react';
import { themes, hexToRgba } from '../data/themes';

const PreferencesPage = ({ active, themeId, onSelectTheme }) => (
  <section className={`section ${active ? 'active' : ''}`} data-testid="preferences-section">
    <div className="section-header">
      <div>
        <div className="section-title">App Preferences</div>
        <div className="section-subtitle">Sesuaikan tampilan antarmuka dan pengaturan aplikasi.</div>
      </div>
    </div>

    <div className="glass-panel">
      <div className="glass-panel-header">
        <div className="glass-panel-title">TEMA APLIKASI</div>
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', fontFamily: "'JetBrains Mono'" }}>12 PILIHAN TERSEDIA</div>
      </div>
      <div className="panel-body" style={{ padding: '24px' }}>
        <div className="theme-grid">
          {themes.map(t => (
            <div
              key={t.id}
              className={`theme-card ${t.id === themeId ? 'active' : ''}`}
              onClick={() => onSelectTheme(t.id)}
              data-testid={`theme-card-${t.id}`}
            >
              <div className="theme-preview" style={{ background: t.bg1 }}>
                <div className="tp-sidebar" style={{ background: t.bg2 }}></div>
                <div className="tp-bg">
                  <div style={{ width: '100%', height: '10px', background: t.bg3, borderRadius: '4px' }}></div>
                  <div style={{ width: '70%', height: '10px', background: t.bg3, borderRadius: '4px' }}></div>
                  <div className="tp-accent" style={{ background: t.accent, boxShadow: `0 0 10px ${hexToRgba(t.accent, 0.6)}` }}></div>
                </div>
              </div>
              <div className="theme-name">{t.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default PreferencesPage;
